/****************************************************************
 * WARNING THIS FILE IS AUTOGENERATED AND SHOULD NOT BE MODIFIED *
 ****************************************************************/
import * as React from "react"
import Svg from "@oui/system/Svg"
type DefaultProps = typeof defaultProps
type SvgProps = React.ComponentPropsWithoutRef<typeof Svg>
type Props = DefaultProps &
  Omit<SvgProps, "fill" | "height" | "stroke" | "viewBox" | "width">
const defaultProps = {
  label: "Thumbnails",
  size: 20
}

const SvgThumbnails = ({ size, ...props }: Props) => (
  <Svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="currentcolor"
    stroke="currentcolor"
    {...props}
  >
    <path
      fill="none"
      d="M3.5 3.5h5v5h-5zM11.5 3.5h5v5h-5zM11.5 11.5h5v5h-5zM3.5 11.5h5v5h-5z"
    />
  </Svg>
)

SvgThumbnails.defaultProps = defaultProps
export default SvgThumbnails
